import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VelaroComponent } from './components/icon/velaro.component';
import { VelaroRunService } from './run/velaro.run.service';
import { TranslateModule } from '@client/app/modules/translate.module';
import { MonEventTriggerModule } from '@monsido/angular-shared-components';

export function initializeVelaro (velaroRunService: VelaroRunService): () => Promise<void> {
    return () => Promise.resolve().then(() => {
        velaroRunService.setupEventListeners();
        return;
    });
}

@NgModule({
    declarations: [
        VelaroComponent,
    ],
    imports: [
        CommonModule,
        TranslateModule,
        MonEventTriggerModule,
    ],
    exports: [
        VelaroComponent,
    ],
    providers: [
        VelaroRunService,
        provideAppInitializer(() => {
            const initializerFn = (initializeVelaro)(inject(VelaroRunService));
            return initializerFn();
        }),
    ],
})
export class VelaroModule { }
